import { Component, Injector, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { GridBaseComponent } from '../../../../../components/common/grid-base/grid-base';
import { PolluxGridConfig } from '../../../../../components/common/pollux-grid-config/pollux-grid-config';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';
import { ValuationEventsWorkspaceComponent } from '../../workspaces/valuation-events-workspace/valuation-events-workspace.component';
import { valuationEventGridColumns } from './valuation-events-grid-config';
import { AppStorageService } from '../../../../../services/app-storage.service';

/**
 * Valuation events grid
 */
@Component({
  selector: 'valuation-events-grid',
  templateUrl: './valuation-events-grid.component.html',
  styleUrls: ['./valuation-events-grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ValuationEventsGridComponent extends GridBaseComponent implements OnInit {
  /**
   * A reference to the Kendo grid component
   */
  @ViewChild(GridComponent) kendoGrid: GridComponent;

  /**
   * A reference to the workspace
   */
  public get workspaceReference(): WorkspaceBase {
    return this.workspace;
  }

  /**
   * Gets a list of columns
   * @returns
   */
  public getColumns(): PolluxGridConfig[] {
    return valuationEventGridColumns;
  }

  /**
   * The workspace
   */
  @Input() workspace: ValuationEventsWorkspaceComponent;

  /**
   * Constructor
   * @param injector
   * @param appStorage
   */
  constructor(protected injector: Injector, private appStorage: AppStorageService) {
    super(injector, 'valuationPortfolio', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();
  }

  /**
   * Handle a row selection / deselection event
   * @param _event The event. Can be null!
   * @param item The item. If an item was deselected, it's null
   */
  protected handleRowSelection(_event: any, item: any): void {
    if (_event || item) {
      this.appStorage.setSelectedPortfolio(item);
    }

    this.eventBus.broadcastEvent('project-valuation-infobar-item-changed', {
      mode: 'valuationProject',
      item: item,
      itemIdentityProperty: 'Oid'
    });

    if (item) {
      this.workspace.onElementSelected(item);
    }
    else if (_event) {
      this.workspace.onElementDeselected();
    }
  }

  /**
   * Handle a doubleclick event
   * @param _event The event. Can be null!
   * @param item The item
   */
  protected handleDoubleClick(_event: any, item: any): void {
    this.workspace.showForm(item.Oid);
    this.eventBus.broadcastEvent('hideImportNavigationActions');
    this.eventBus.broadcastEvent('isValuationEventChild', item.ParentId > 0);
  }

  /**
   * Gets the url for loading a paged list
   * @returns The url for loading a paged list
   */
  protected getPagedListEndpoint(): string {
    return this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `ValuationPortfolios/list/paged`);
  }

  /**
   * Reset the filters and show all items
   */
  public showAll(): void {
    super.showAll(null);
    this.workspace.onShowAll();
  }

  /**
   * Data loading callback
   * @param data The loaded data
   */
  protected onDataLoaded(data: GridDataResult): void {
    this.workspace.setCounterValue('valuationPortfolio', data.total);
  }

  /**
   * Apply a filter
   * @param filter
   * @param selectedItemOid
   * @returns
   */
  public applyFilter(filter: any, selectedItemOid: number): Promise<any> {
    if (!filter) {
      this.appStorage.setSelectedProject(null);//on every load, reset selected project
      this.appStorage.setSelectedPortfolio(null);//also portfolio is not selected anymore
    }

    return super.applyFilter(filter, selectedItemOid);
  }

  /**
   * Callback to apply CSS classes to grid row
   */
  public rowClassCallback = (context: RowClassArgs) => {
    const rowClasses: any = {
      recordStatusInactive: context.dataItem.RecordStatusId === 2
    };

    return rowClasses;
  };
}
